import moment from "moment";
import colors from "styles/Colors";
import { tokens } from "styles/Tokens";
import { getUIFormatDate } from "utils/DateHelper";
import Typography from "../../common/Typography";

interface Props {
  data: any;
  tab?: string;
}

function PlanBadge(props: Props) {
  const { data } = props;

  if (data?.myPlans && data?.myPlans[0]?.title === data?.name) {
    return (
      <>
        <Typography
          component={"span"}
          variant={"label"}
          changeVariant={false}
          color={colors.Cyan.Cyan400}
          showBold
          sx={{
            marginBottom: "4px",
            "&::before": {
              content: '""',
              display: "inline-block",
              height: "8px",
              width: "8px",
              borderRadius: "100%",
              backgroundColor: colors.Cyan.Cyan400,
              marginRight: "4px"
            }
          }}
        >
          In My plans
        </Typography>
      </>
    );
  }

  if (data?.dueDate) {
    let date = new Date();
    let yesterday = date.setDate(date.getDate() - 1);
    const isOverdue = moment(data?.dueDate).isBefore(moment(yesterday));
    return (
      <>
        <Typography
          variant={"label"}
          changeVariant={false}
          color={isOverdue ? colors.Orange.Orange400 : tokens.Text.General.Tertiary}
          showBold
          sx={{
            marginBottom: "4px",
            "&::before": {
              content: '""',
              display: "inline-block",
              height: "8px",
              width: "8px",
              borderRadius: "100%",
              backgroundColor: isOverdue ? colors.Orange.Orange400 : tokens.Text.General.Tertiary,
              marginRight: "4px"
            }
          }}
        >
          {isOverdue ? "Overdue" : "Duedate"}
          <Typography variant="label" changeVariant={false}>
            {isOverdue ? " since" : ""}
            {` ${getUIFormatDate(data?.dueDate)}`}
          </Typography>
        </Typography>
      </>
    );
  }
  return null;
}
export default PlanBadge;
